// Your five quick-dance slots (keys 1-5, and the radial Dance Wheel): any dances you own, swapped on the wheel.
// Stored on the profile as `danceSlots` (an array of five dance ids / null).
import { G } from '../core/ctx.js';
import { MATCH_EMOTES, isDanceUnlocked } from './actor.js';
import { saveCloudProgress } from '../auth/account.js';

export const SLOT_COUNT = 5;
const DEFAULT_SLOTS = ['booyah', 'wave', 'dance', 'flex', null];

/** Every dance, once each, in catalogue order: [{ id, label, emoji }]. */
export function danceList() {
  const seen = new Set(), out = [];
  for (const d of Object.values(MATCH_EMOTES)) { if (seen.has(d.id)) continue; seen.add(d.id); out.push({ id: d.id, label: d.label, emoji: d.emoji }); }
  return out;
}

/** The five slots, with anything you no longer own / that no longer exists emptied. */
export function getDanceSlots() {
  let raw = null;
  try {
    raw = G.game && G.game.profile && G.game.profile.danceSlots;
    if (!Array.isArray(raw)) raw = JSON.parse(localStorage.getItem('slimeduel.profile') || '{}').danceSlots;
  } catch { raw = null; }
  const ids = new Set(danceList().map((d) => d.id));
  const slots = Array.isArray(raw) ? raw.slice(0, SLOT_COUNT) : DEFAULT_SLOTS.slice();
  while (slots.length < SLOT_COUNT) slots.push(null);
  return slots.map((id) => (id && ids.has(id) && isDanceUnlocked(id) ? id : null));
}

export function saveDanceSlots(slots) {
  const clean = Array.from({ length: SLOT_COUNT }, (_, i) => slots[i] || null);
  try { if (G.game && G.game.profile) G.game.profile.danceSlots = clean; } catch { /* no game yet */ }
  try {
    const cur = JSON.parse(localStorage.getItem('slimeduel.profile') || '{}');
    cur.danceSlots = clean;
    localStorage.setItem('slimeduel.profile', JSON.stringify(cur));
  } catch { /* private mode */ }
  try { saveCloudProgress(); } catch { /* guest */ }
  return clean;
}
